import User from "./User"

export default class UserWithAccessRights extends User {
    constructor(id, firstName, lastName, middleName, username, active, emailExists, userGroupId, timeZoneGroupId, isPTO, isSick, isOvertimeTracking, overtimeTrackingLevel, accessRights) {
        super(id, firstName, lastName, middleName, username, active, emailExists, userGroupId, timeZoneGroupId, isPTO, isSick, isOvertimeTracking, overtimeTrackingLevel);
        this.accessRight = accessRights;
        // TODO: replace all usages of "accessRight" with "accessRights"
        this.accessRights = accessRights;
    }

    setOvertimeEnabled(overtimeEnabled) {
        this.overtimeEnabled = overtimeEnabled;
    }

    isOvertimeEnabled() {
        return this.overtimeEnabled;
    }

    clone() {
        return new UserWithAccessRights(this.id, this.firstName, this.lastName, this.middleName, this.username, this.active,
            this.emailExists, this.userGroupId, this.timeZoneGroupId, this.isPTO, this.isSick, this.isOvertimeTracking, this.overtimeTrackingLevel,
            this.accessRight)
    }

    static fromRPC(data) {
        return new UserWithAccessRights(
                data["id"], data["firstName"], data["lastName"], data["middleName"], data["username"],
                data["active"], data["emailExists"], data["userGroupId"], data["timeZoneGroupId"], data["isPTO"], data["isSick"],
                data["isOvertimeTracking"], data["overtimeTrackingLevel"], data["accessRights"]
        )
    }
}


// WEBPACK FOOTER //
// ./web/js/store/UserWithAccessRights.js